import { getCampaignsPagination, getCampaignStat } from "@/api/campaign";
import { useQuery } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { toValue } from "vue";

interface UseCampaignsOptions {
  keyword?: MaybeRefOrGetter<string>;
  time_from?: MaybeRefOrGetter<number>;
  time_to?: MaybeRefOrGetter<number>;
  page?: MaybeRefOrGetter<number>;
  size?: MaybeRefOrGetter<number>;
  refetchInterval?: number;
  refetchIntervalInBackground?: boolean;
}

export function useCampaigns(options: UseCampaignsOptions = {}) {
  const {
    keyword,
    time_from,
    time_to,
    page,
    size,
    refetchInterval,
    refetchIntervalInBackground,
  } = options;

  const queryParams = () => ({
    keyword: toValue(keyword) || undefined,
    time_from: toValue(time_from) || 0,
    time_to: toValue(time_to) || 0,
    page: toValue(page) || 1,
    size: toValue(size) || 100,
  });

  const {
    data: campaigns,
    isLoading: isLoadingCampaigns,
    isError,
    error,
  } = useQuery({
    queryKey: ["campaigns", queryParams],
    queryFn: () =>
      getCampaignsPagination(queryParams() as Record<string, unknown>),
    refetchInterval,
    refetchIntervalInBackground,
  });

  const { data: campaignStats, isLoading: isLoadingStats } = useQuery({
    queryKey: ["campaignStats", queryParams],
    queryFn: () => getCampaignStat(),
  });

  const getStatForCampaign = (campaignId: string) => {
    console.log(
      campaignStats.value?.data?.find((stat) => stat._id === campaignId)
        ?.count || 0,
    );
    return (
      campaignStats.value?.data?.find((stat) => stat._id === campaignId)
        ?.count || 0
    );
  };

  return {
    campaigns,
    isLoadingCampaigns,
    isLoadingStats,
    isError,
    error,
    campaignStats,
    getStatForCampaign,
  };
}
